import { render, staticRenderFns } from "./addOrg.vue?vue&type=template&id=f0929c24&scoped=true"
import script from "./addOrg.vue?vue&type=script&lang=js"
export * from "./addOrg.vue?vue&type=script&lang=js"
import style0 from "./addOrg.vue?vue&type=style&index=0&id=f0929c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0929c24",
  null
  
)

export default component.exports